module.exports = __webpack_public_path__ + "static/media/dhime.1f19ce83.ogg";